import React from "react"

import Avatar from "@mui/material/Avatar"
import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import Typography from "@mui/material/Typography"

import { useHistory } from "react-router-dom"

import { formatRelative } from "date-fns"
import { ptBR } from "date-fns/locale"

const ListItemComponent = ({
    profilePicUrl,
    name,
    lastMessage,
    time,
    uuid,
}) => {
    const history = useHistory()

    return (
        <ListItem
            sx={{ gap: 2, justifyContent: "space-between", cursor: "pointer" }}
            divider
            onClick={() => history.push(`/tickets/${uuid}`)}
        >
            <Box display="flex" alignItems="center" gap={2}>
                <Avatar src={profilePicUrl} />
                <Box>
                    <Typography variant="subtitle1">{name}</Typography>
                    <Typography
                        variant="caption"
                        sx={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {lastMessage}
                    </Typography>
                </Box>
            </Box>
            <Box>
                <Typography variant="caption">
                    {formatRelative(time, new Date(), { locale: ptBR })}
                </Typography>
            </Box>
        </ListItem>
    )
}

function InactiveLeadsCard({ data = [] }) {
    return (
        <Card
            sx={{
                borderRadius: 2,
                boxShadow: 1,
                height: 355,
                overflowY: "auto",
            }}
        >
            <CardContent>
                <Typography variant="h6" color="text.secondary">
                    Negociações sem retorno
                </Typography>
                <List dense>
                    {data.map((item) => (
                        <ListItemComponent
                            key={item.id}
                            name={item.contactName}
                            lastMessage={item.lastMessage}
                            profilePicUrl={item.contactProfilePic}
                            time={item.lastMessageAt}
                            uuid={item.uuid}
                        />
                    ))}
                </List>
            </CardContent>
        </Card>
    )
}

export default InactiveLeadsCard
